// extracted by mini-css-extract-plugin
module.exports =  {"info":"a10a3f92e9--info--XltzK","link":"a10a3f92e9--link--jpabx"};